import VideoPlayOverlayIcon from '@atlaskit/icon/core/video-play-overlay';
import * as React from 'react';

export function SvgPlay() {
  return <VideoPlayOverlayIcon label="" testId="ads-refreshed-icon" />;
}
